import { createApp } from 'vue'
import __t from "../../../helpers/translate";
import vue_helpers from "../../../helpers/check_null";
import userProfile from "./user/userProfile.vue";
import userNotification from "./user/userNotification.vue";

import {createBootstrap} from 'bootstrap-vue-next';


window.G_HEADER = createApp({
    name : "G_HEADER",
    id : "G_HEADER",
    components : {
        userprofile : userProfile,
        usernotification : userNotification,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

G_HEADER.mount('#user_options');